import { createFileRoute } from '@tanstack/react-router'
import { ClockInSettingsFeature } from '@/features/organizations/settings/clock-in'
import { WorkforceLocationSettingsFeature } from '@/features/organizations/settings/workforce-location'

/**
 * Combined "Location Tracking" settings: the workforce-location policy
 * (tracking mode + workplace surveillance notice) decides *whether/how*
 * workers are tracked; the clock-in geofence configures the operational
 * detail of that tracking at clock-in. They share one page since the
 * surveillance notice covers the clock-in GPS collection.
 */
function LocationSettings() {
  return (
    <div className='space-y-10'>
      <WorkforceLocationSettingsFeature />
      <div className='border-t border-border' />
      <ClockInSettingsFeature />
    </div>
  )
}

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/clock-in'
)({
  component: LocationSettings,
})
